import BaseModel from './BaseModel';

class ReportSchedule extends BaseModel {}

ReportSchedule.collection = 'ReportSchedules';

export default ReportSchedule;
